var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between items-end"},[_c('div',{staticClass:"flex items-center"},[_c('export-button',{attrs:{"is-exporting":_vm.isExporting},on:{"click":_vm.exportCustomers}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }